import * as Api from "products/widgets/api";
// Helpers
import { notifier } from "common/notifier";
//-------------------------------------------------------------------------------------------------------------------------------
export const SET_FEATURED_AGENT = "WIDGET_SET_FEATURED_AGENT";
export const SET_FEATURED_LISTING = "WIDGET_SET_FEATURED_LISTING";
export const SET_SPOTLIGHT_LISTING = "WIDGET_SET_SPOTLIGHT_LISTING";
export const createAction_SetFeaturedAgent = (url) => {
    return {
        type: SET_FEATURED_AGENT,
        url: url
    };
};
export const createAction_SetFeaturedListing = (url) => {
    return {
        type: SET_FEATURED_LISTING,
        url: url
    };
};
export const createAction_SetSpotlightListing = (url) => {
    return {
        type: SET_SPOTLIGHT_LISTING,
        url: url
    };
};
//-------------------------------------------------------------------------------------------------------------------------------
export const getFeaturedAgentWidgetUrl = (officeId) => {
    return (dispatch) => {
        // Fetch
        Api.async_FeaturedAgentRequest(dispatch, officeId)
            .then((url) => {
            dispatch(createAction_SetFeaturedAgent(url));
        }, (message) => {
            notifier.notifyError("Error", message);
        });
    };
};
export const getFeaturedListingWidgetUrl = (officeId) => {
    return (dispatch) => {
        // Fetch
        Api.async_FeaturedListingRequest(dispatch, officeId)
            .then((url) => {
            dispatch(createAction_SetFeaturedListing(url));
        }, (message) => {
            notifier.notifyError("Error", message);
        });
    };
};
export const getSpotlightListingWidgetUrl = (officeId) => {
    return (dispatch) => {
        // Fetch
        Api.async_SpotlightListingRequest(dispatch, officeId)
            .then((url) => {
            dispatch(createAction_SetSpotlightListing(url));
        }, (message) => {
            notifier.notifyError("Error", message);
        });
    };
};
//-------------------------------------------------------------------------------------------------------------------------------
